import React, { useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';
import { getSymptom, questionsToAsk } from '../../data/symptoms';
interface AskYourClinicianProps {
  selected: string[];
}
export function AskYourClinician({
  selected
}: AskYourClinicianProps) {
  const [copied, setCopied] = useState(false);
  const questions = questionsToAsk(selected);
  const labels = selected.map(id => getSymptom(id)?.label).filter(Boolean);
  const summary = ['What I am experiencing:', ...labels.map(label => `· ${label}`), '', 'What I want to ask:', ...questions.map(question => `· ${question}`)].join('\n');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(summary);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2400);
    } catch {
      setCopied(false);
    }
  };
  return <section aria-labelledby="ask-heading" className="rounded-brand border border-brick/35 bg-cream p-7 md:p-10" data-id="element-93" data-mp="xvgq4mamc13u">
      <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-94" data-mp="3owj56exo45o3">Take this with you</p>
      <h3 id="ask-heading" className="mt-4 font-serif text-3xl leading-tight text-ink" data-id="element-95" data-mp="3jxzl6k2mx3yd">
        The questions to ask, written out for you
      </h3>
      <p className="mt-4 max-w-2xl leading-relaxed text-ink-soft" data-id="element-96" data-mp="1to5ttjl3vgb">
        Bring this to any clinician — including one who is not us. Specific questions are much
        harder to answer with reassurance alone, and you should not have to compose them at 8:40 in
        the morning in a ten-minute appointment.
      </p>

      <ol className="mt-8 flex flex-col" data-id="element-97" data-mp="6p3iii5uvlb5">
        {questions.map((question, index) => <li key={question} className="rule flex gap-5 py-4 first:border-t-0" data-id="element-98" data-mp="kht96zwbxeel" data-mpi={index}>
            <span className="mt-0.5 font-serif text-lg text-brick" aria-hidden="true" data-id="element-99" data-mp="ghj19hoz8dx3">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="leading-relaxed text-ink" data-id="element-100" data-mp="phxkmbidrixy">{question}</span>
          </li>)}
      </ol>

      <button type="button" onClick={copy} className="mt-8 inline-flex items-center gap-2 rounded-brand border border-ink/30 px-6 py-3 text-sm font-medium text-ink transition-colors duration-150 ease-brand hover:border-ink hover:bg-ink hover:text-cream" data-id="element-101" data-mp="3ja724mwwmgnv">
        {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="vxsy0nwdnv7" /> : <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="5v0zxqnfu45t" />}
        {copied ? 'Copied to your clipboard' : 'Copy my summary'}
      </button>
      <p className="mt-4 text-sm text-ink-soft" data-id="element-104" data-mp="asao72z3c9s2">
        Nothing here is stored, sent anywhere, or attached to an email address.
      </p>
    </section>;
}